export default class CurrencyItem
{
	constructor (item) 
	{
		if (item === undefined)
		{
			this.CurrencyId = "";
			this.Code = "";
			this.Description = "";
			this.IsActive = "";
			return;
		}
		this.CurrencyId = item.currencyId;
		this.Code = item.code;
		this.Description = item.description;
		this.IsActive = item.isActive;
	}
}
